export const allowedOrders = [
  ["y", "x"],
  ["x", "y"],
  ["r", "\\theta"],
  ["\\theta", "r"],
  ["z", "y", "x"],
  ["z", "r", "\\theta"],
  ["\\rho", "\\phi", "\\theta"],
];